import { FC } from 'react';

import { RootState } from 'store/rootReducer';

import { useAppSelector } from 'hooks/defaultStoreHooks';

import { DrawerSection } from 'components/drawerSections/DrawerSections';
import HandelseList from 'components/utkast/handelseList/HandelseList';
import { OmradeFormValues } from 'components/utkast/utkastRegistration/UtkastFormSchema';

import { HandelseTypEnum } from 'enums';

import { useFormikContext } from 'formik';

const TillkomstSection: FC = () => {
  const { values, setFieldValue } = useFormikContext<OmradeFormValues>();
  const domaner = useAppSelector((state: RootState) => state.bebyggelseobjektDomaner.data);

  return (
    <DrawerSection>
      <fieldset>
        <legend className="tw-heading-md tw-mb-4">Tillkomst</legend>
        <HandelseList
          handelserValues={values.handelser}
          excludeType={domaner?.handelsetyper.map((h) => h.handelsetyp).filter((h) => h !== HandelseTypEnum.TILLKOMST)}
          setFieldValue={setFieldValue}
          handelseName="tillkomstår"
          maxCount={1}
        />
      </fieldset>
    </DrawerSection>
  );
};

export default TillkomstSection;
